import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupDirective } from './directives/popup/popup.directive';
import { PopupContainerComponent } from './components/popup-container/popup-container.component';
import { IdeomUiCommonModule } from '../common/ideom-ui-common.module';

@NgModule({
  declarations: [PopupDirective, PopupContainerComponent],
  imports: [CommonModule, IdeomUiCommonModule],
  exports: [PopupDirective],
  entryComponents: [PopupContainerComponent],
})
export class IdeomPopupModule {}
